/** @jsx jsx */

import { Select, SelectItem } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

type TimePeriodDaysItem = {
  label: string;
  value: number;
};

type DateRangeDropdownProps<T extends TimePeriodDaysItem> = {
  initialSelectedItem: T;
  items: T[];
  onSelect: (timePeriod: T['value']) => void;
};

const styleRoot = css`
  min-width: 156px;
`;

export default function DateRangeDropdown<T extends TimePeriodDaysItem>({
  items,
  initialSelectedItem,
  onSelect,
}: DateRangeDropdownProps<T>) {
  return (
    <div css={styleRoot}>
      <Select
        label="Period"
        isLabelHidden
        defaultSelectedKey={String(initialSelectedItem.value)}
        onChange={key => {
          const item = items.find(i => String(i.value) === String(key));
          if (item) {
            onSelect(item.value);
          }
        }}
        placeholder="Choose a range..."
      >
        {items.map(item => (
          <SelectItem key={String(item.value)} value={String(item.value)}>
            {item.label}
          </SelectItem>
        ))}
      </Select>
    </div>
  );
}
